$(document).ready(function () {
    //l1
    $('#btnMenu').click(function(e) {
        $('.ctn-main-menu').addClass('opn-l1');
        $('.backdrop').toggleClass('open-backdrop menu-open');
        e.stopPropagation();
    });
    $('.backdrop').on('click', function() {
        $('.ctn-main-menu').removeClass('submenu-on');
    });
    $('.btnCloseMenu').click(function() {
        $('.ctn-main-menu').removeClass('opn-l1');
        $('.ctn-mn-l2').removeClass('opn-l2');
        $('.ctn-mn-l3').removeClass('opn-l3');
        $('.backdrop').removeClass('open-backdrop menu-open');
        $('.link-l1').removeClass('active');
        $('.ctn-main-menu').removeClass('submenu-on');
        closeCall()
	});

	//l2
    $("[data-submenu-l1='true']").on('mouseenter', function(e){
        $(".ctn-mn-l2").removeClass("opn-l2");
        $('.ctn-main-menu').addClass('submenu-on');
        $(this).find(".ctn-mn-l2").addClass("opn-l2");
        $('.link-l1').removeClass('active');
		$(this).find('.link-l1').addClass('active');
		
        e.stopPropagation()
    });
    $("[data-submenu-l1='true']").on('mouseleave', function(e){
        $(this).find(".ctn-mn-l2").removeClass("opn-l2");
        $(this).find(".ctn-mn-l3").removeClass("opn-l3");
        $(this).find('.link-l1').removeClass('active');
        $('.ctn-main-menu').removeClass('submenu-on');
        e.stopPropagation();
    });
    $(document).on('click', "[data-submenu-l1='true'] > span", function(e) {
        if (window.matchMedia('(min-width: 768px)').matches) return;
        $(".ctn-mn-l2").removeClass("opn-l2");
        $('.link-l1').removeClass('active');
        var $li = $(this).parent();
        $('.ctn-main-menu').addClass('submenu-on');
        $li.find('.ctn-mn-l2').addClass('opn-l2');
        $li.find('.link-l1').addClass('active');

        e.stopPropagation();
    });

    $(document).on('click', '.l2-back, .l2-back > a', function(e) {
        $(this).closest('.ctn-mn-l2').removeClass('opn-l2');
        $(this).closest("[data-submenu-l1='true']").find('.link-l1').removeClass('active');
        $('.ctn-main-menu').removeClass('submenu-on');

        e.preventDefault();
        e.stopPropagation();
    });

    //l3
    $('[data-submenu-l2=\'true\'] > span').click(function(e) {
        $(this).parent().find('.ctn-mn-l3').addClass('opn-l3');
        e.stopPropagation();
    });
    $('.l3-back').click(function() {	
		$(this).closest('.ctn-mn-l3').removeClass('opn-l3');
	    $(this).closest('.link-l2').removeClass('active');
	});
});